interface Key {
  [key: string]: string
}

export const sortByDatetime = (array: [], key: string) => {
  array.sort((a: Key, b: Key) => b[key].localeCompare(a[key]))
}
